module.exports = __webpack_public_path__ + "img/02-HIW.c6c859f9.png";